var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Popper } from '../../internal/Popper';
import classnames from 'classnames';
import { PopoverContent, PopoverDivider, PopoverFooter, PopoverHeader, } from './components';
export const Popover = React.forwardRef((_a, ref) => {
    var { width = 's', padding = 'm', portal = false, children, className, contentNoPadding, footer, footerAlign, header, headerAlign, headerNoPadding, popoverContentClassName, scrollHeight, sharp, wrapperClassName, open, focusTrapOptions = { disabled: true }, offset = { skidding: 0, distance: 4 }, portalDataAttributes } = _a, props = __rest(_a, ["width", "padding", "portal", "children", "className", "contentNoPadding", "footer", "footerAlign", "header", "headerAlign", "headerNoPadding", "popoverContentClassName", "scrollHeight", "sharp", "wrapperClassName", "open", "focusTrapOptions", "offset", "portalDataAttributes"]);
    const PopoverBaseWidth = 16;
    const widthSwitch = () => {
        switch (width) {
            case 'l':
                return PopoverBaseWidth * 40;
            case 'm':
                return PopoverBaseWidth * 32;
            case 's':
                return PopoverBaseWidth * 20;
            case 'xs':
                return PopoverBaseWidth * 12;
            case '100':
                return `100`;
            default:
                return `auto`;
        }
    };
    const PopoverBodyClasses = classnames('Popover__body', className, {
        [`Popover--p-${padding}`]: padding,
        [`Popover--w-auto`]: width === 'auto',
        'Popover__body--sharp': sharp,
        'Popover__body--portal': portal,
        'Popover__body--open': open,
    });
    const PopoverClasses = classnames('Popover', wrapperClassName, {
        'Popover--portal': portal,
        'Popover--open': open,
    });
    return (React.createElement(Popper, Object.assign({ className: PopoverClasses, bodyClassName: PopoverBodyClasses, width: widthSwitch(), portal: portal, ref: ref, open: open, offset: offset, focusTrapOptions: focusTrapOptions, "data-anvil-component": "Popover", "data-portal-popover": open && portal ? 'open' : undefined, portalDataAttributes: portalDataAttributes }, props),
        header && (React.createElement(PopoverHeader, { noPadding: headerNoPadding, align: headerAlign }, header)),
        React.createElement(PopoverContent, { contentScrollHeight: scrollHeight, noPadding: contentNoPadding, className: popoverContentClassName }, children),
        footer && (React.createElement(PopoverFooter, { align: footerAlign }, footer))));
});
Popover.Header = PopoverHeader;
Popover.Footer = PopoverFooter;
Popover.Content = PopoverContent;
Popover.Divider = PopoverDivider;
//# sourceMappingURL=Popover.js.map